import { all } from 'redux-saga/effects';
import watchContactSaga from './contactSaga';

export default function* rootSaga() {
  yield all([watchContactSaga()]);
}
